import {html, css, LitElement, live, svg, keyed, ref, createRef} from 'lit';

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
}

function cloneTree(tree) {
    let new_tree = {...tree}
    for (let [k0, item] of Object.entries(tree)) {
        if (item.children && Object.values(item.children).length) {
            let new_item = {...item}
            new_item.children = cloneTree(item.children)
            new_tree[k0] = new_item
        } else {
            new_tree[k0] = item
        }
    }
    return new_tree
}

function flattenTree(tree) {
    let items = []
    for (let item of Object.values(tree)) {
        items.push(item)
        if (item.children && Object.values(item.children).length) {
            items.push(...flattenTree(item.children)) 
        }
    }
    return items
} 

const scrollbar_style = css`
*::-webkit-scrollbar {
  height: 7px;
  width: 5px;
}
*::-webkit-scrollbar-track {
  border-radius: 0px;
  background-color: #FFFFFF;
}

*::-webkit-scrollbar-track:hover {
  background-color: #ffffff;
}

*::-webkit-scrollbar-track:active {
  background-color: #ffffff;
}

*::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ececec;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #ececec;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #ececec;
}
`


class AdminSiteMenuEditorModel {
    constructor() {
        this.commit_id = generateUUID()
        this.found = { menu: null, catalog: null }
        this.nodes = { menu: {}, catalog: {} }
        this.options = {
            menu: { leaf_mode: false,  show_free: false},
            catalog: { leaf_mode: false, show_free: false}
        } 
        this.exchange = { source: null, target: null }
        this._listeners = []
        this.changed = false
        this.loadData()
    }
    
    async loadData() {
        let [menu, catalog] = await Promise.all([this.loadMenuData(), this.loadCatalogData()])
        this.dataset = { menu: menu, catalog: catalog }
        this.markBadSections()
        this.updateCatalogCounts()
        this.initializeIndices()
        this.notify('update')
    }

    loadMenuData() {
        return BX.ajax.runAction('dz:content.api.menu.getMenu', {
            data: {},
        })
        .then(resp => { return resp && resp.data })
        .catch(err => { console.error(err) })
    }

    saveMenuData() {
        if (this.dataset.menu) {
            let items = this.#filterMenu(false, () => false)
            if (Object.values(items).length) {
                BX.ajax.runAction('dz:content.api.menu.saveMenu', {
                    data: { items: items },
                })
                .then(resp => {
                    this.changed = false
                    this.notify('update')
                    BX.UI.Notification.Center.notify({
                        content: "Данные меню обновлены",
                        position: "bottom-right"
                    });
                })
                .catch(err => { console.error(err) })
            }
        }
    }

    loadCatalogData() {
        return BX.ajax.runAction('dz:content.api.catalog.getHierarchy', {
            data: {},
        })
        .then(resp => { return resp && resp.data })
        .catch(err => { console.error(err) })
    }

    updateCatalogCounts() {
        let count = tree => {
            let counter = 0
            for (let item of Object.values(tree)) {
                if (item.children && Object.values(item.children).length) {
                    item.count = count(item.children)
                }
                counter += item.count   
            }
            return counter
        }
        count(this.dataset.catalog)
    }

    commitChanges(notify = false, evt_id = 'update') {
        this.commit_id = generateUUID()
        this.changed = true
        this.markBadSections()
        if (notify) {
            this.notify(evt_id)
        }
    }

    listen(event_id, object_id, callback) {
        if (this._listeners[event_id]) {
            this._listeners[event_id][object_id] = callback
        } else {
            this._listeners[event_id] = {
                object_id: callback
            }
        }
    }

    notify(event_id, data = null) {
        let keys = ['*', event_id]        
        for (let key of keys) {
            if (this._listeners[key]) {
                for (let [id, callback] of Object.entries(this._listeners[key])) {
                    callback(event_id, data)
                }
            }
        }
    }

    getTerminalNodes(tree) {
        let accum = []
        for (let item of Object.values(tree)) {
            if (item.children) {
                accum.push(...this.getTerminalNodes(item.children))
            } else {
                accum.push(item)
            }
        }
        return accum
    }

    getLinks() {
        if (this.dataset && this.dataset.menu) {
            let collect = menu => {
                let sections = []
                for (let item of Object.values(menu)) {
                    if (item['SECTION_ID']) { 
                        sections.push(item['SECTION_ID'])
                    }
                    if (item.children) {
                        sections.push(...collect(item.children))
                    }
                }
                return sections
            }
            return collect(this.dataset.menu)
        }
    }

    getFreeSections(leaf_mode = false) {
        if (this.dataset && this.dataset.catalog) {
            let links = new Set(this.getLinks()),
                catalog = cloneTree(this.dataset.catalog),
                filter = items => {
                    for (let [key, item] of Object.entries(items)) {
                        if (item.children && Object.values(item.children).length) {
                            filter(item.children)
                            if (Object.values(item.children).length == 0) {
                                delete item.children
                            }
                        }
                        if (item.link || links.has(item.id.toString())) {
                            delete items[key]
                        }
                    }
                    return items
                }
            if (leaf_mode) {
                return flattenTree(filter(catalog))
            } else {
                return filter(catalog)
            }
        }
    }

    #filterMenu(keep_tree, predicate) {
        if (this.dataset && this.dataset.menu) {
            if (keep_tree) {
                let tree = cloneTree(this.found.menu ? this.found.menu : this.dataset.menu),
                    crop = (tree) => {
                        for (let [key, item] of Object.entries(tree)) {
                            if (predicate(item) && !item.children) {
                                delete tree[key]
                            }
                            if (item.children) {
                                crop(item.children)
                                if (!Object.values(item.children).length) {
                                    delete tree[key]
                                }
                            }
                        }
                        return tree
                    }
                return crop(tree)
            } else {
                let result = {}
                for (let node of this.getTerminalNodes(this.dataset.menu)) {
                    if (!predicate(node)) {
                        result[node['ID']] = node
                    }
                }
                return result
            }
        } 
    }

    markBadSections() {
        let count_bad = tree => {
            let count = 0
            for (let item of Object.values(tree)) {
                delete item.bad
                if (item.children) {
                    let bad_children = count_bad(item.children)
                    if (bad_children) {
                        item.bad = true
                        count += 1
                    }
                } else {
                    if (('SECTION_ID' in item && !Number(item['SECTION_ID'])) || (!Number(item['ITEM_COUNT']))) {
                        item.bad = true
                        count += 1
                    }
                }
            }
            return count
        }
        count_bad(this.dataset.menu)
    }

    getBadMenuItems(keep_tree = true, keep_unlinked = true, keep_empty = true) {
        let tree = this.#filterMenu(keep_tree, item => {
            let condition = true
            if (keep_unlinked) {
                condition &&= ('SECTION_ID' in item && Number(item['SECTION_ID']))
            }
            if (keep_empty) {
                condition &&= Number(item['ITEM_COUNT'])
            }
            return condition
        })
        return tree
    }

    initializeIndices() {
        let options = {preset: "performance", tokenize: "forward"},
            extractors = { menu: tree => this.getTerminalNodes(tree), catalog: flattenTree }

        this.index = {
            menu: FlexSearch.Index(options),
            catalog: FlexSearch.Index(options),
            nodes: {}
        }
        

        for (let [key, tree] of Object.entries(this.dataset)) {
            let nodes = extractors[key](tree)
            this.index.nodes[key] = Object.assign(...nodes.map(node => ({ [node.id || node['ID']] : node }) ))
            for (let item of nodes) {
                item.id && item.name && this.index[key].add(item.id, item.name)
                item['ID'] && item['ITEM_NAME'] && this.index[key].add(item['ID'], item['ITEM_NAME'])
            }
        }
    }

    getItems(where) {
        if (this.found[where]) {
            return this.found[where]
        } else {
            return this.dataset[where]
        }
    }

    findItems(where, query) {
        let nodes = this.index.nodes[where]
        if (nodes) {
            let result = [],
                ids = this.index[where].search(query)
            for (let id of ids) {
                result.push(nodes[id])
            }
            if (result.length) {
                this.found[where] = result
            }
        }
        return this.found[where]
    }

    clearFound(where) {
        delete this.found[where]
    }
}


const arrow_down = svg`
<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.50971 0.0888672H0.490296C0.219769 0.0888672 0.0687127 0.3745 0.236247 0.569499L4.74595 5.79878C4.87504 5.94846 5.12359 5.94846 5.25405 5.79878L9.76375 0.569499C9.93129 0.3745 9.78023 0.0888672 9.50971 0.0888672Z" fill="#00B2FF" fill-opacity="0.88"/>
</svg>
`

const link_arrow = svg`
<svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1504 9.11816L13.7254 7.71816L15.8254 5.61816H0.650391V3.61816H15.8254L13.7504 1.51816L15.1754 0.118164L19.6504 4.61816L15.1504 9.11816Z" fill="black"/>
</svg>
`

class CommonTree extends LitElement {
    static get properties() {
        return {
            tree: {type: Object, state: true},
            padding: { type: Number }
        }
    }

    render() {
        if (this.tree) {
            return this.renderTree(this.tree)
        }
    }

    renderTree(tree, level = 0) {
        let result = []
        for (let item of Object.values(tree)) {
            result.push(this.renderItem(item, level))
        }
        return html`${result}`
    }

    expandSpoiler(evt) {
        let spoiler = evt.detail.closest('.spoiler')
        if (spoiler) {
            if (!spoiler.classList.contains('open')) {
                spoiler.classList.add('open')
            }
            evt.stopPropagation()
            spoiler.parentNode.dispatchEvent(new CustomEvent('expand', { detail: spoiler.parentNode, bubbles: true, composed: true })) 
        }
    }

    toggleSpoiler(evt) {
        let spoiler = evt.target.closest('.spoiler')
        spoiler.classList.toggle('open')
        evt.stopPropagation()
    }

    chooseItem(evt, item, destination) {
        if (this.model) {
            let old_item = null
            if (this.model.exchange[destination]) {
                this.model.exchange[destination].node.classList.remove('exchange')
                old_item = this.model.exchange[destination].item 
                this.model.exchange[destination] = null
            }
            if (item !== old_item) {
                let node = evt.target.closest('.item')
                this.model.exchange[destination] = { item: item, node: node }
                node.classList.add('exchange')
            }
        }
    }

    static get styles() {
        return css`
            :host {
                padding: 10px;
                display: flex;
                flex-direction: column;
                font-size: 12px;
                font-weight: bold;
                gap: 10px;
            }

            .spoiler {
                cursor: pointer;
            }

            .spoiler > .children {
                display: none;
                padding: 10px 0px;
                flex-direction: column;
                gap: 10px;
            }

            .spoiler.open > .children {
                display: flex;
            }

            .spoiler > .header {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            .spoiler > .header .arrow {
                transform: scale(0.8) rotate(-90deg);
                display: inline-block;
                transform-origin: center;
            }

            .spoiler.bad > .header .arrow {
                filter: hue-rotate(180deg) brightness(0.3) saturate(10);
            }

            .spoiler.open > .header .arrow {
                transform: scale(0.8) rotate(0deg);
                display: inline-block;
                transform-origin: center;
            }
        `
    }
}


class CommonItemReadout extends LitElement {
    static get properties() {
        return {
            model: { type: Object, state: true }, 
            item: { type: Object, state: true },
        }
    }

    render() { 
        if (this.item) {
            let item_data = this.getItemData(this.item)            
            return html`
                <div class="item ${item_data.is_empty ? "empty" : "" }">
                    <span class="name">${item_data.name && item_data.name.length ? item_data.name : 'Без названия'}</span>
                    ${Number(item_data.count) ? html`<span class="count">${item_data.count} эл.</span>` : ``}
                    ${item_data.link ? html`<span class="link" @click=${evt => this.displayLink(evt, item_data.link) }>[${item_data.link}]</span>` : ``}
                    <span class="arrow">${link_arrow}</span>
                </div>
            `
        }
    }

    makeVisible() {
        this.dispatchEvent(new CustomEvent('expand', { detail: this, bubbles: true, composed: true }))
        this.animate( [{ background: `rgba(163, 211, 255, 0.65)` }, { background: `rgba(163, 211, 255, 0.0)` }], { duration: 2000, easing: 'linear', fill: 'forwards' })
        setTimeout(() => {
            this.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
        }, 50)
    }

    static get styles() {
        return css`
            .item {
                display: flex;
                align-items: center;
                gap: 10px;
                font-weight: normal;
                color: black;
                cursor: pointer;
            }

            .item.empty {
                color: red;
                font-weight: bold;
            }

            :host {
                border-radius: 10px;
                outline: solid white 1px;
                transition: 0.2s;
            }       

            .link:hover {
                text-decoration: underline;
            }

            .arrow {
                transition: 0.3s;
                opacity: 0;
            }

            :host(.exchange) .arrow {
                opacity: 1;
            }

            :host(.inactive) * {
                color: #0004;
            }   
        `
    }
}

class MenuItemReadout extends CommonItemReadout {
    getItemData(item) {
        return {
            name: item['ITEM_NAME'],
            count: item['ITEM_COUNT'],
            link: item['SECTION_ID'],
            is_empty: !(Number(item['SECTION_ID']) && Number(item['ITEM_COUNT']) > 0)
        }
    }

    displayLink(evt, link) {
        if (this.item && this.model && link) {
            let link_node = this.model.nodes.catalog[link]
            if (link_node) {
                link_node.makeVisible()
            }
        }
        evt.stopPropagation()
    }

    updated() {
        if (this.item && this.model) {
            this.model.nodes.menu[this.item['ID']] = this
        }
    }
}
window.customElements.define("menu-item-readout", MenuItemReadout) 


class CatalogItemReadout extends CommonItemReadout {
    getItemData(item) {
        return {
            name: item.name,
            count: item.count,
            link: item.link,
            is_empty: !(Number(item.count) > 0 || (item.children && Object.values(item.children).length))
        }
    }

    displayLink(evt, link) {
        if (this.item && this.model) {
            let link_node = this.model.nodes.menu[link]
            link_node.makeVisible()
        }
        evt.stopPropagation()
    }

    updated() {
        if (this.item && this.model) {
            this.model.nodes.catalog[this.item.id] = this
            if (this.item.children && Object.values(this.item.children).length) {
                this.classList.add('folder')
            } else {
                this.classList.remove('folder')
            }
        }
    }

    static get styles() {
        return [
            super.styles,
            css`
                :host(.folder) .name {
                    font-weight: bold;
                }
            `
        ]
    }

}
window.customElements.define("catalog-item-readout", CatalogItemReadout) 



class AdminMenuTree extends CommonTree {    
    renderItem(item, level) {
        if (item.children) {
            return html`
                <div class="spoiler ${item.bad ? "bad" : ""}" style="padding-left: ${this.padding * level}px" @click=${this.toggleSpoiler} @expand=${this.expandSpoiler}>
                    <div class="header">
                        <span class="arrow">${arrow_down}</span>
                        <span class="name">${item.name || item['ITEM_NAME']}</span>
                    </div>
                    <div class="children" @click=${evt => evt.stopPropagation() }>
                        ${this.renderTree(item.children, level + 1)}
                    </div>
                </div> 
            `
        } else {
            return html`
                <menu-item-readout class="item" .model=${this.model} .item=${item} style="padding-left: ${this.padding * level}px" @click=${evt => this.chooseItem(evt, item, 'source')}></menu-item-readout>
            `
        }
    }
}

window.customElements.define("admin-menu-tree", AdminMenuTree) 


class AdminCatalogTree extends CommonTree {  
    renderItem(item, level) {
        let is_active = item.active === 'Y'
        if (item.children) {
            return html`
                <div class="spoiler ${item.bad ? "bad" : ""} ${is_active ? "" : "inactive"}" style="padding-left: ${this.padding * level}px" @click=${this.toggleSpoiler} @expand=${this.expandSpoiler}>
                    <div class="header">
                        <span class="arrow">${arrow_down}</span>
                        <catalog-item-readout .model=${this.model} .item=${item} class="item ${is_active ? "" : "inactive"}"  @click=${evt => this.chooseItem(evt, item, 'target')}></catalog-item-readout>
                    </div>
                    <div class="children" @click=${evt => evt.stopPropagation() }>
                        ${this.renderTree(item.children, level + 1)}
                    </div>
                </div> 
            `
        } else {
            return html`
                <catalog-item-readout .model=${this.model} .item=${item} class="item ${is_active ? "" : "inactive"}" style="padding-left: ${this.padding * level}px" @click=${evt => this.chooseItem(evt, item, 'target')}></catalog-item-readout>
            `
        }
    }

    chooseItem(evt, item, destination) {
        if (this.model.exchange.source) {
            let src = this.model.exchange.source.item,
                src_node = this.model.exchange.source.node,
                dst_node = evt.target.closest('catalog-item-readout')
            src['SECTION_ID'] = item.id
            src['SECTION_NAME'] = item.name
            src['ITEM_COUNT'] = item.count

            item.link = src['ID']
            src_node.classList.remove('exchange')
            src_node.requestUpdate()
            dst_node.requestUpdate()      
            this.model.exchange.source = null
            this.model.commitChanges(true, 'changed')            
            evt.stopPropagation()
        }
    }

    static get styles() {
        return [
            super.styles,
            css`
                .item {
                    font-weight: normal;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .item.empty {
                    color: red;
                    font-weight: bold;
                }

                .item.exchange {
                    outline: solid blue 1px;
                }

                .spoiler.inactive,
                .item.inactive {
                    color: #0005;
                }
            `            
        ]
    }
}
window.customElements.define("admin-catalog-tree", AdminCatalogTree)


const search_icon = svg`
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.8129 18.7754L10.5129 12.4754C10.0129 12.8754 9.43789 13.1921 8.78789 13.4254C8.13789 13.6587 7.44622 13.7754 6.71289 13.7754C4.89622 13.7754 3.35872 13.1462 2.10039 11.8879C0.842057 10.6296 0.212891 9.09206 0.212891 7.27539C0.212891 5.45872 0.842057 3.92122 2.10039 2.66289C3.35872 1.40456 4.89622 0.775391 6.71289 0.775391C8.52956 0.775391 10.0671 1.40456 11.3254 2.66289C12.5837 3.92122 13.2129 5.45872 13.2129 7.27539C13.2129 8.00872 13.0962 8.70039 12.8629 9.35039C12.6296 10.0004 12.3129 10.5754 11.9129 11.0754L18.2129 17.3754L16.8129 18.7754ZM6.71289 11.7754C7.96289 11.7754 9.02539 11.3379 9.90039 10.4629C10.7754 9.58789 11.2129 8.52539 11.2129 7.27539C11.2129 6.02539 10.7754 4.96289 9.90039 4.08789C9.02539 3.21289 7.96289 2.77539 6.71289 2.77539C5.46289 2.77539 4.40039 3.21289 3.52539 4.08789C2.65039 4.96289 2.21289 6.02539 2.21289 7.27539C2.21289 8.52539 2.65039 9.58789 3.52539 10.4629C4.40039 11.3379 5.46289 11.7754 6.71289 11.7754Z" fill="#1C1B1F"/>
</svg>
`

const eye_icon = svg`
<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7734 12.7754C13.0234 12.7754 14.0859 12.3379 14.9609 11.4629C15.8359 10.5879 16.2734 9.52539 16.2734 8.27539C16.2734 7.02539 15.8359 5.96289 14.9609 5.08789C14.0859 4.21289 13.0234 3.77539 11.7734 3.77539C10.5234 3.77539 9.46094 4.21289 8.58594 5.08789C7.71094 5.96289 7.27344 7.02539 7.27344 8.27539C7.27344 9.52539 7.71094 10.5879 8.58594 11.4629C9.46094 12.3379 10.5234 12.7754 11.7734 12.7754ZM11.7734 10.9754C11.0234 10.9754 10.3859 10.7129 9.86094 10.1879C9.33594 9.66289 9.07344 9.02539 9.07344 8.27539C9.07344 7.52539 9.33594 6.88789 9.86094 6.36289C10.3859 5.83789 11.0234 5.57539 11.7734 5.57539C12.5234 5.57539 13.1609 5.83789 13.6859 6.36289C14.2109 6.88789 14.4734 7.52539 14.4734 8.27539C14.4734 9.02539 14.2109 9.66289 13.6859 10.1879C13.1609 10.7129 12.5234 10.9754 11.7734 10.9754ZM11.7734 15.7754C9.3401 15.7754 7.12344 15.0962 5.12344 13.7379C3.12344 12.3796 1.67344 10.5587 0.773438 8.27539C1.67344 5.99206 3.12344 4.17122 5.12344 2.81289C7.12344 1.45456 9.3401 0.775391 11.7734 0.775391C14.2068 0.775391 16.4234 1.45456 18.4234 2.81289C20.4234 4.17122 21.8734 5.99206 22.7734 8.27539C21.8734 10.5587 20.4234 12.3796 18.4234 13.7379C16.4234 15.0962 14.2068 15.7754 11.7734 15.7754ZM11.7734 13.7754C13.6568 13.7754 15.3859 13.2796 16.9609 12.2879C18.5359 11.2962 19.7401 9.95872 20.5734 8.27539C19.7401 6.59206 18.5359 5.25456 16.9609 4.26289C15.3859 3.27122 13.6568 2.77539 11.7734 2.77539C9.8901 2.77539 8.16094 3.27122 6.58594 4.26289C5.01094 5.25456 3.80677 6.59206 2.97344 8.27539C3.80677 9.95872 5.01094 11.2962 6.58594 12.2879C8.16094 13.2796 9.8901 13.7754 11.7734 13.7754Z" fill="black"/>
</svg>
`

const tree_icon = svg`
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.73438 18.7754V10.8004C7.66771 10.8004 6.64271 10.5962 5.65938 10.1879C4.67604 9.77956 3.80938 9.20039 3.05938 8.45039C2.30938 7.70039 1.73438 6.83372 1.33438 5.85039C0.934375 4.86706 0.734375 3.84206 0.734375 2.77539V0.775391H2.73438C3.78438 0.775391 4.80104 0.979557 5.78438 1.38789C6.76771 1.79622 7.63438 2.37539 8.38438 3.12539C8.90104 3.64206 9.33021 4.20872 9.67188 4.82539C10.0135 5.44206 10.276 6.10039 10.4594 6.80039C10.5427 6.68372 10.6344 6.57122 10.7344 6.46289C10.8344 6.35456 10.9427 6.24206 11.0594 6.12539C11.8094 5.37539 12.676 4.79622 13.6594 4.38789C14.6427 3.97956 15.6677 3.77539 16.7344 3.77539H18.7344V5.77539C18.7344 6.84206 18.5302 7.86706 18.1219 8.85039C17.7135 9.83372 17.1344 10.7004 16.3844 11.4504C15.6344 12.2004 14.7719 12.7754 13.7969 13.1754C12.8219 13.5754 11.801 13.7754 10.7344 13.7754V18.7754H8.73438ZM8.73438 8.77539C8.73438 7.97539 8.58021 7.21289 8.27187 6.48789C7.96354 5.76289 7.52604 5.11706 6.95937 4.55039C6.39271 3.98372 5.74687 3.54622 5.02187 3.23789C4.29688 2.92956 3.53437 2.77539 2.73438 2.77539C2.73438 3.57539 2.88438 4.34206 3.18438 5.07539C3.48438 5.80872 3.91771 6.45872 4.48438 7.02539C5.05104 7.59206 5.70104 8.02539 6.43438 8.32539C7.16771 8.62539 7.93437 8.77539 8.73438 8.77539ZM10.7344 11.7754C11.5344 11.7754 12.2969 11.6254 13.0219 11.3254C13.7469 11.0254 14.3927 10.5921 14.9594 10.0254C15.526 9.45872 15.9635 8.80872 16.2719 8.07539C16.5802 7.34206 16.7344 6.57539 16.7344 5.77539C15.9344 5.77539 15.1677 5.92956 14.4344 6.23789C13.701 6.54622 13.051 6.98372 12.4844 7.55039C11.9177 8.11706 11.4844 8.76289 11.1844 9.48789C10.8844 10.2129 10.7344 10.9754 10.7344 11.7754Z" fill="#1C1B1F"/>
</svg>
`

const leaf_icon = svg`
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.02344 16.021C7.0901 16.021 6.21094 15.8752 5.38594 15.5835C4.56094 15.2918 3.80677 14.8793 3.12344 14.346L1.72344 15.721C1.5401 15.9043 1.30677 15.996 1.02344 15.996C0.740104 15.996 0.506771 15.9043 0.323438 15.721C0.140104 15.5377 0.0484375 15.3043 0.0484375 15.021C0.0484375 14.7377 0.140104 14.5043 0.323438 14.321L1.69844 12.946C1.1651 12.2627 0.752604 11.5043 0.460938 10.671C0.169271 9.83766 0.0234375 8.95433 0.0234375 8.021C0.0234375 5.78766 0.798437 3.896 2.34844 2.346C3.89844 0.795996 5.7901 0.0209961 8.02344 0.0209961H16.0234V8.021C16.0234 10.2543 15.2484 12.146 13.6984 13.696C12.1484 15.246 10.2568 16.021 8.02344 16.021ZM8.02344 14.021C9.6901 14.021 11.1068 13.4377 12.2734 12.271C13.4401 11.1043 14.0234 9.68766 14.0234 8.021V2.021H8.02344C6.35677 2.021 4.9401 2.60433 3.77344 3.771C2.60677 4.93766 2.02344 6.35433 2.02344 8.021C2.02344 8.671 2.12344 9.29183 2.32344 9.8835C2.52344 10.4752 2.79844 11.0127 3.14844 11.496L8.32344 6.321C8.50677 6.13766 8.7401 6.046 9.02344 6.046C9.30677 6.046 9.5401 6.13766 9.72344 6.321C9.92344 6.521 10.0234 6.7585 10.0234 7.0335C10.0234 7.3085 9.92344 7.546 9.72344 7.746L4.54844 12.921C5.03177 13.271 5.56927 13.5418 6.16094 13.7335C6.7526 13.9252 7.37344 14.021 8.02344 14.021Z" fill="#1C1B1F"/>
</svg>
`

const backspace_icon = svg`
<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.72656 14.4585C6.39323 14.4585 6.08073 14.3835 5.78906 14.2335C5.4974 14.0835 5.2599 13.8752 5.07656 13.6085L0.726562 7.4585L5.07656 1.3085C5.2599 1.04183 5.4974 0.833496 5.78906 0.683496C6.08073 0.533496 6.39323 0.458496 6.72656 0.458496H16.7266C17.2766 0.458496 17.7474 0.654329 18.1391 1.046C18.5307 1.43766 18.7266 1.9085 18.7266 2.4585V12.4585C18.7266 13.0085 18.5307 13.4793 18.1391 13.871C17.7474 14.2627 17.2766 14.4585 16.7266 14.4585H6.72656ZM6.72656 12.4585H16.7266V2.4585H6.72656L3.17656 7.4585L6.72656 12.4585ZM9.12656 11.4585L11.7266 8.8585L14.3266 11.4585L15.7266 10.0585L13.1266 7.4585L15.7266 4.8585L14.3266 3.4585L11.7266 6.0585L9.12656 3.4585L7.72656 4.8585L10.3266 7.4585L7.72656 10.0585L9.12656 11.4585Z" fill="#1C1B1F"/>
</svg>
`


class EditorToolbar extends LitElement {
    $searchinput = createRef()

    static get properties() {
        return {
            target: { type: String }
        }
    }

    constructor() {
        super()
        this.show_free_items = false
        this.show_tree = true
    }

    render() {
        let query = this.$searchinput.value ? this.$searchinput.value.value.trim() : ""

        return html`
            <div class="searchbar">
                <input type="text" @input=${this.search} ${ref(this.$searchinput)}>
                <div class="icon" @click=${this.clearSearch}>${ query.length ? backspace_icon : search_icon }</div>
            </div>
            <button class="toggle ${ this.show_free_items ? "active" : "" }" @click=${this.toggleFreeMode}>
                ${eye_icon}
                <span>Без привязки</span>
            </button>
            <button class="mode ${ !this.show_free_items || this.model.found[this.target] ? "disabled" : "" } ${ this.show_tree ? "active" : "" } " @click=${this.toggleTreeMode}>
                ${this.show_tree ? tree_icon : leaf_icon }
            </button>
        `
    }

    search() {
        if (this.$searchinput.value && this.model) {
            let query = this.$searchinput.value.value.trim()
            if (query.length) {
                this.model.findItems(this.target, query)
            } else {
                this.model.clearFound(this.target)
            }
            this.model.commitChanges(true)
            this.requestUpdate()
        }
    }

    clearSearch() {
        if (this.model) {
            let query = this.$searchinput.value.value.trim()
            if (query.length) {
                this.$searchinput.value.value = ""
                this.model.clearFound(this.target)
                this.model.commitChanges(true)
                this.requestUpdate()
            }
        }
    }

    toggleFreeMode() {
        if (this.target) {
            this.show_free_items = !this.show_free_items
            this.model.options[this.target].show_free = this.show_free_items
            this.model.commitChanges(true)
            this.requestUpdate()
        }
    }

    toggleTreeMode() {
        if (this.target && this.show_free_items) {
            this.show_tree = !this.show_tree
            this.model.options[this.target].leaf_mode = !this.show_tree
            this.model.commitChanges(true)
            this.requestUpdate()
        }
    }

    static get styles() {
        return css`
            :host {
                display: grid;
                grid-template-columns: 1fr 150px 50px;
                gap: 10px;
                padding: 10px;
                margin-bottom: 10px;
                box-sizing: border-box;
            }

            button {
                appearance: none;
                border: none;
                background: #F6F6F6;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 5px;
                box-sizing: border-box;
                cursor: pointer;
                height: 35px;
                transition: 0.2s;
            }

            button:hover {
                box-shadow: inset 0px 4px 10.6px rgba(0, 0, 0, 0.25);
            }

            button.toggle.active {
                background: #00B2FF;
            }

            button.toggle.active > * {
                filter: invert();
            }

            button.disabled {
                pointer-events: none;
            }

            button.disabled > *{
                opacity: 0.3;
            }

            .searchbar {
                background: #F6F6F6;
                border-radius: 6px;
                display: flex;
                position: relative;
            }

            .searchbar .icon {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
            }

            .searchbar input {
                width: 100%;
                appearance: none;
                background: none;
                border: none;
                padding: 5px;
            }

            .searchbar input:focus {
                outline: none;
                padding: 0px 10px;
            }
        `
    }
}
window.customElements.define("editor-toolbar", EditorToolbar)


class AdminSiteMenuEditor extends LitElement {
    $save =  createRef()

    constructor() {
        super()
        window.objectStorage.makeItem(" AdminSiteMenuEditor.split.main", 400)
        this.model = new AdminSiteMenuEditorModel()
        this.model.listen('update', this, (evt_id, data) => {
            this.requestUpdate()
        })
        this.model.listen('changed', this, (evt_id, data) => {
            this.$save.value.classList.remove('disabled')
        })
    }

    saveChanges() {
        if (this.model) {
            this.model.saveMenuData()
        }
    }

    render() {
        if (this.model) {
            let menu_items = this.model.dataset && this.model.getItems('menu'),
                catalog_items = this.model.dataset && this.model.getItems('catalog')

            if (this.model.options.menu.show_free) {
                menu_items = this.model.getBadMenuItems(!this.model.options.menu.leaf_mode)
            }

            if (this.model.options.catalog.show_free) {
                catalog_items = this.model.getFreeSections(this.model.options.catalog.leaf_mode)
            }

            return html`
                <div class="titlebar">
                    <div class="title">Связка  меню и разделов</div>
                    ${keyed(this.model.changed, html`<button class=${this.model.changed ? "normal" : "disabled"} @click=${this.saveChanges} ${ref(this.$save)}>Сохранить</button>`)}            
                </div>
                <split-view split=" AdminSiteMenuEditor.split.main" vertical reversed thin>
                    <div class="pane menu">
                        <editor-toolbar .model=${this.model} target="menu"></editor-toolbar>
                        <admin-menu-tree .model=${this.model} .tree=${menu_items} .padding=${20}></admin-menu-tree>
                    </div>
                    <div class="pane catalog">
                        <editor-toolbar .model=${this.model} target="catalog"></editor-toolbar>
                        <admin-catalog-tree .model=${this.model} .tree=${catalog_items} .padding=${20}></admin-catalog-tree>
                    </div>  
                </split-view>
            `
        }
    }

    static get styles() {
        return [
            scrollbar_style,
            css`
                :host {
                    display: block;
                }

                .titlebar button.disabled {
                    pointer-events: none;
                    opacity: 0.3;
                }

                .titlebar {
                    background: #B1C0C3;
                    margin-bottom: 10px;
                    border-radius: 8px;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .titlebar .title {
                    background: none;
                    font-weight: bold;
                    color: #545B5C;
                    padding-left: 10px;
                }

                .titlebar button {
                    appearance: none;
                    border: none;
                    background: #7F959B;
                    padding: 8px;
                    border-radius: 8px;
                    box-sizing: border-box;
                    width: 120px;
                    color: white;
                    font-weight: bold;
                }

                .pane {
                    background: white;
                    border-radius: 10px;
                }

                .pane.menu {
                    margin-right: 4px;
                }

                .pane.catalog {
                    margin-left: 4px;
                }

                split-view::part(slider) {
                    opacity: 0;
                }
        `]
    }
}

window.customElements.define("admin-site-menu-editor", AdminSiteMenuEditor)